import API_URLS from "../helper/api-urls";
import ApiHelper from "../helper/api-helper";

const getTwilioLookup = (body) => {
  return ApiHelper.postRequest(`${API_URLS.GET_SMS_TWILIO_LOOKUP}`, body);
};

export const SmsService = {
  getTwilioLookup,
};
